export const NOISE_REDUCTION_MODES = ['off', 'auto', 'strong'] as const;
export type NoiseReduction = typeof NOISE_REDUCTION_MODES[number];
export const MUSIC_VOLUMES = ['low', 'medium', 'high'] as const;
export type MusicVolume = typeof MUSIC_VOLUMES[number];
export const MUSIC_VOLUME_LABELS: Record<MusicVolume, string> = {
  low: 'Тихо', medium: 'Средне', high: 'Громко',
};
/** Линейный вес музыки в amix под голосом; medium — прежний уровень. */
export const MUSIC_VOLUME_WEIGHTS: Record<MusicVolume, number> = {
  low: 0.11, medium: 0.22, high: 0.36,
};
export const NOISE_REDUCTION_LABELS: Record<NoiseReduction, string> = {
  off: 'Нет', auto: 'Мягко', strong: 'Сильнее',
};
